<template>
  <div>
    <el-dialog
      title="选择成员"
      :visible.sync="dialogVisible"
      :mode="mode"
      width="634px"
      :before-close="closeDialog"
    >
      <div class="left-trrr">
        <div class="tree-box">
          <template v-if="dialogVisible">
            <el-tree
              :showLine="showLine"
              :load="loadNode"
              :props="defaultProps"
              :node-key="nodeKey"
              :default-expanded-keys="expandedKeys"
              lazy
              @node-click="handleNodeClick"
              @node-expand="showChildNode"
              :render-content="renderContent"
            >
            </el-tree>
          </template>
        </div>
      </div>

      <div class="selected">
        <p class="selected-count">已选成员 ({{ selected.length }})</p>
        <ul class="selected-ul">
          <template v-for="(item, index) in selected">
            <li class="selected-li" :key="index">
              <i
                style="margin-right: 5px"
                class="icon-ccui-man-hollow"
                :style="{ color: selectedIconColor }"
                @click="removeArray(selected, item)"
              ></i>
              <span class="selected-name">{{ item.name }}</span>
              <i
                class="el-icon-close mt"
                @click="removeArray(selected, item)"
              ></i>
            </li>
          </template>
        </ul>
      </div>

      <div size="mini" type="default-mini" slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="closeDialog"
          >取消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="confirmForm"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getArgs } from "@/basa/utils";
import { qryOrgTreeUser } from "@/app/sourceManage/api/expert.js";

export default {
  name: "purchaserAgent",
  props: {
    schemeId: {
      type: String,
      default: ""
    },
    initiateVisible: {
      type: Boolean,
      default: false
    },
    selectedIconColor: {
      type: String,
      default: "#0089ef"
    },
    opUnitId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      mode: "radio",
      dialogVisible: false,
      expandedKeys: [],
      treeData: [],
      selected: [],
      firstCode: "",
      selectedCode: [],
      renderParams: {},
      resolve: Function,
      ishowTree: true,
      expandedlog: {},
      expandArr: [],
      agentId: getArgs("a"),
      orgId: Number(this.$store.state.user.userDetal.orgId),
      baseAppId: Number(this.$store.state.user.userDetal.appId),
      showLine: false,
      nodeKey: "treeId",
      defaultProps: {
        label: "name",
        children: "zones",
        isLeaf: "isLeaf"
      }
    };
  },
  watch: {
    initiateVisible: {
      handler(val) {
        this.dialogVisible = val;
        this.selected = [];
      },
      immediate: true
    },
    opUnitId: {
      handler(val) {
        this.opUnitId = val;
        if (this.node) {
          this.selected = [];
          this.node.childNodes = [];
          this.node.level = 0;
          this.loadNode(this.node, this.resolve);
        }
      },
      immediate: true
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("update:initiateVisible", false);
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.node = node;
        this.resolve = resolve;
        qryOrgTreeUser({
          flag: "2",
          isOrgan: "1",
          isOrganAll: "1",
          parentId: this.opUnitId
        }).then(res => {
          const nodes = res.data.data.map(item => ({
            id: item.id,
            orgId: item.orgId,
            name: item.name,
            code: item.code,
            abbrName: item.abbrName,
            deptId: item.deptId,
            isLeaf: item.isLeaf,
            opendId: item.openID,
            userId: item.userId,
            child: item.child,
            partyId: item.partyId
          }));
          return resolve(nodes);
        });
      } else {
        qryOrgTreeUser({
          flag: "2",
          isOrgan: "1",
          isOrganAll: "1",
          parentId: node.data.partyId
        }).then(res => {
          const nodes = res.data.data[0].child.map(item => ({
            id: item.id,
            orgId: item.orgId,
            name: item.name,
            code: item.code,
            abbrName: item.abbrName,
            deptId: item.deptId,
            opendId: item.openID,
            userId: item.userId,
            // isLeaf: item.isLeaf,
            isLeaf: Number(item.orgType) === 2,
            child: item.child,
            partyId: item.partyId
          }));
          resolve(nodes);
        });
      }
    },
    handleNodeClick(data, node, tree) {
      if (data.isLeaf) {
        if (this.mode === "radio") {
          this.selected.forEach(item => (item.isSelected = false));
          if (data.isLeaf) {
            this.selected = [data];
            data.isSelected = true;
          } else {
            this.$message({
              type: "error",
              message: "当前节点不能选择",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        } else {
          if (!data.isSelected) {
            data.isSelected = true;
            this.selected.push(data);
            this.selectedCode.push(data.autoCode);
          } else {
            this.removeArray(this.selected, data);
          }
        }
      }
    },
    showChildNode(data, node) {},
    renderContent(h, { node, data, store }) {
      let isSelectedHtml, leafIcon;
      if (data.isSelected) {
        isSelectedHtml = (
          <i class="el-icon-check" style="margin-right:15px"></i>
        );
      }
      if (data.isLeaf) {
        leafIcon = <i class="icon-ccui-man-hollow is-leaf-org"></i>;
      }
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            {leafIcon}
            <span>{node.label}</span>
          </span>
          <span>{isSelectedHtml}</span>
        </span>
      );
    },
    removeArray(arr, delItem) {
      let condeIndex = this.selectedCode.indexOf(delItem.autoCode);
      this.selectedCode.splice(condeIndex, 1);
      delItem.isSelected = false;
      let index = arr.indexOf(delItem);
      arr.splice(index, 1);
    },
    confirmForm() {
      if (this.selected.length) {
        this.$emit("setSelectedNode", this.selected[0]);
        this.$emit("update:initiateVisible", false);
      } else {
        this.$message({
          type: "success",
          message: "请选择成员!"
        });
      }
    }
  }
};
</script>
<style scoped>
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.selected-name {
  color: #4a4a4a;
}
.el-icon-close {
  float: right;
  cursor: pointer;
}
.selected-li {
  line-height: 18px;
  margin: 10px auto;
}
/deep/ .el-dialog__body {
  padding: 20px;
}

.el-tree >>> .is-leaf-org {
  padding-left: -10px;
  padding-right: 6px;
  color: #0089ef;
}

.custom-tree-node {
  width: 106px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
}

.left-trrr {
  width: 300px;
  float: left;
  border: 1px solid #f1f1f1;
  padding-top: 10px;
}
.tree-box {
  height: calc(100vh - 360px);
  overflow: auto;
  padding: 0 12px;
}
.selected {
  float: right;
  border: 1px solid #f1f1f1;
  width: 270px;
}

.selected-count {
  color: #4a4a4a;
  font-size: 14px;
  padding: 10px 20px;
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 16px;
}
.selected-ul li {
  font-size: 14px;
  margin: 0;
  padding: 0 20px 12px 20px;
}
.selected-ul li:first-child {
  margin-top: 3px;
}
.mt {
  margin-top: 2px;
}
.selected-ul {
  height: calc(100vh - 366px);
  overflow: auto;
}
.org-name {
  line-height: 18px;
}
.org-name span {
  font-size: 13px;
  color: #4a4a4a;
}
.org-full-name {
  line-height: 18px;
  margin-top: 5px;
  font-size: 13px;
  color: #999999;
  margin-left: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.org-icon {
  color: #0089ef;
  margin-right: 5px;
}
</style>
